// tslint:disable: typedef

import React from 'react';
import HyperLinkRenderer from 'components/common/DataGridDevEx/CustomRenderers/HyperLinkRenderer';

export function createHyperLinkCell(config) {
    const {
        getValue,        // function to build `value` prop
        link,            // link URL
        headerName = '', // optional header
        visibleIf,       // optional condition to check
    } = config;

    return function HyperLinkCell({ data: { data } }) {
        if (!data) return null;

        if (visibleIf && !visibleIf(data)) return null;

        const value = getValue(data);

        if (!value) return null;

        return (
            <HyperLinkRenderer
                value={value}
                colDef={{ headerName }}
                link={link}
            />
        );
    };
}
